export const getClubIdFromPath = (path?: string) => {
  if (!path) return '';

  const result = path.match(/club\/([a-fA-F\d]+(?:-[a-fA-F\d]+){1,})/);

  return result ? result[1] : '';
};
